<template>
  <div>
    <div class="product-window group-con" :class="attr.cartAttr === true ? 'on' : ''"
      :style="'padding-bottom:' + (isShowBtn ? '0' : '')">
      <div class="textpic acea-row row-between-wrapper">
        <div class="pictrue">
          <img :src="attr.cartData.image" class="image" />
        </div>
        <div class="text">
          <div class="line1">
            {{ attr.cartData.store_name }}
          </div>
          <div class="money font-color-red">
            ￥<span class="num">{{ attr.cartData.price }}</span>
            <span class="stock">
              库存: {{ attr.cartData.stock }}
            </span>
          </div>
        </div>
        <div class="iconfont icon-guanbi" @click="closeAttr"></div>
      </div>
      <div class="productWinList">
        <div class="item" v-for="(item, indexw) in attr.productAttr" :key="indexw">
          <div class="title">{{ item.attr_name }}</div>
        </div>
      </div>
      <div class="cart">
        <div class="title" v-if="!(attr.type == 57)">充值金额</div>
        <div class="carnum acea-row row-left" v-if="!(attr.type == 57)">
          <div class="item reduce" :class="num <= 500 ? 'on' : ''" @click="CartNumDes">
            -
          </div>
          <div class="item num">
            <input type="number" v-model="num" class="ipt_num" readonly="readonly" />
          </div>
          <div class="item plus " @click="CartNumAdd">
            +
          </div>
        </div>
        <div class="footer acea-row row-between-wrapper">
          <div>
            {{ attr.type == 57 ? "金额:" : '合计:' }}
            <span class="font-color-red">￥{{ num }}.{{ attr.cartData.price.split('.')[1] }}</span>
          </div>
          <div class="settlement" @click="goVirtualPay(attr.cartData)">立即结算</div>
        </div>
      </div>

    </div>
    <div class="mask" @touchmove.prevent :hidden="attr.cartAttr === false" @click="closeAttr"></div>
  </div>
</template>
<script>
export default {
  name: "ProductWindow",
  props: {
    attr: {
      type: Object,
      default: () => { },
    },
    iSplus: {
      type: String,
      default: "",
    },
  },
  data: function () {
    return {
      type: "",
      num: null,
    };
  },
  computed: {
  },
  watch: {
    attr: {
      handler() { //这是vue的规定写法，当你watch的值发生变化的时候，就会触发这个handler，这是vue内部帮你做的事情
        console.log(this.attr)
        if (this.attr.cartAttr) {
          this.num = this.attr.cartData.price.split('.')[0] * 1;
        }

      },
      deep: true,  // 可以深度检测到 obj 对象的属性值的变化
    }
  },
  mounted: function () {

  },
  methods: {

    // 虚拟卡商品 点击充值  1.加入购物车  2.订单确认  跳转至结算页面
    goVirtualPay(item) {
      // 先加入购物车
      this.$router.push({
        path: "/order/VirtualPay/" + item.cate_id,
        query: {
          pinkid: this.pinkId,
          price: this.num + '.' + this.attr.cartData.price.split('.')[1],
          productId: item.id,
          uniqueId: item.unique,
        }, // cartId:res.data.cartId+""}
      });
    },
    closeAttr: function () {
      this.attr.cartAttr = false;
    },
    CartNumDes: function () {
      if (this.num == this.attr.cartData.price.split('.')[0]) return;
      this.num = this.num - 100;
    },
    CartNumAdd: function () {

      this.num = this.num + 100;
    },
  },
};
</script>
<style scoped>
.joinCart {
  width: 80%;
  height: 0.76rem;
  line-height: 0.76rem;
  text-align: center;
}

.ipt_num {
  width: 100%;
  display: block;
  line-height: 0.54rem;
  text-align: center;
}

.footer .settlement {
  font-size: 0.3rem;
  color: #fff;
  width: 2.4rem;
  height: 0.7rem;
  background-color: #e93323;
  border-radius: 0.5rem;
  text-align: center;
  line-height: 0.7rem;
}

.footer {
  width: 100%;
  height: 1rem;
  background-color: #fff;
  padding: 0 0.3rem;
  font-size: 0.28rem;
  color: #333;
  position: fixed;
  bottom: 0;
  left: 0;
}
</style>
